import { useRef } from "react";
import { useTranslation } from "react-i18next";

/**
 * Modal listing clients that belong to a clicked geofence (idGeocerca === geocerca.value).
 */
export default function ModalClientesPorGeocercaMapa({ isOpen, onClose, geocercaItem = null, clientes = [] }) {
    const { t } = useTranslation();
    const modalRef = useRef(null);

    if (!isOpen || !geocercaItem) {
        return null;
    }

    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    const nombreGeocerca = geocercaItem.label ?? geocercaItem.nombreGeocerca ?? "";
    const colorGeo = geocercaItem.colorGeocerca && String(geocercaItem.colorGeocerca).trim() !== ""
        ? geocercaItem.colorGeocerca
        : "#3388ff";
    const list = Array.isArray(clientes) ? clientes : [];

    return (
        <div
            className="fixed z-[70] inset-0 flex items-center justify-center p-4"
            onMouseDown={handleOutsideClick}
        >
            <div className="absolute inset-0 bg-black/10" />

            <div
                ref={modalRef}
                className="relative bg-white rounded-lg shadow-lg w-full max-w-5xl max-h-[90vh] flex flex-col"
            >
                <div className="p-5 border-b flex items-start gap-3">
                    <span
                        className="mt-1 h-4 w-4 shrink-0 rounded border border-gray-200"
                        style={{ backgroundColor: colorGeo }}
                        aria-hidden
                    />
                    <div className="min-w-0 flex-1">
                        <h2 className="text-lg font-semibold text-gray-900">
                            {t("label_clientes_por_geocerca_mapa")}
                        </h2>
                        <p className="text-sm text-gray-600 mt-1 truncate" title={nombreGeocerca}>
                            {nombreGeocerca}
                        </p>
                        <p className="text-xs text-gray-500 mt-1">
                            {list.length} {t("menu_clientes")}
                        </p>
                    </div>
                </div>

                <div className="p-4 overflow-auto flex-1 min-h-0">
                    {list.length === 0 ? (
                        <p className="text-gray-500 text-sm text-center py-8">
                            {t("label_no_hay_informacion_disponible")}
                        </p>
                    ) : (
                        <div className="border border-gray-200 rounded-lg overflow-hidden">
                            <table className="w-full text-sm border-collapse">
                                <thead>
                                    <tr className="bg-gray-50 text-xs font-semibold text-gray-600 border-b border-gray-200">
                                        <th className="text-right py-2 px-3 w-12 whitespace-nowrap">{t("column_nro")}</th>
                                        <th className="text-left py-2 px-3">{t("column_descripcion")}</th>
                                        <th className="text-left py-2 px-3">{t("label_codigo")}</th>
                                        <th className="text-left py-2 px-3">{t("label_tipo_cliente")}</th>
                                        <th className="text-left py-2 px-3">{t("label_ciudad")}</th>
                                        <th className="text-right py-2 px-3 whitespace-nowrap">{t("label_latitud")}</th>
                                        <th className="text-right py-2 px-3 whitespace-nowrap">{t("label_longitud")}</th>
                                        <th className="text-left py-2 px-3">{t("column_habilitado")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {list.map((row, index) => (
                                        <tr
                                            key={row.id ?? `${row.codigo}-${row.latitud}-${row.longitud}`}
                                            className="border-b border-gray-100 hover:bg-gray-50/80"
                                        >
                                            <td className="py-2 px-3 text-right tabular-nums text-gray-600 font-medium whitespace-nowrap">
                                                {index + 1}
                                            </td>
                                            <td className="py-2 px-3 text-gray-900 max-w-[200px]">
                                                <span className="line-clamp-2">{row.descripcion ?? "—"}</span>
                                            </td>
                                            <td className="py-2 px-3 text-gray-800 whitespace-nowrap">
                                                {row.codigo ?? "—"}
                                            </td>
                                            <td className="py-2 px-3 text-gray-700">
                                                {row.tipoCliente ?? "—"}
                                            </td>
                                            <td className="py-2 px-3 text-gray-700">
                                                {row.ciudad ?? "—"}
                                            </td>
                                            <td className="py-2 px-3 text-right font-mono text-xs text-gray-800 whitespace-nowrap">
                                                {row.latitud ?? "—"}
                                            </td>
                                            <td className="py-2 px-3 text-right font-mono text-xs text-gray-800 whitespace-nowrap">
                                                {row.longitud ?? "—"}
                                            </td>
                                            <td className="py-2 px-3 text-gray-700 whitespace-nowrap">
                                                {row.habilitadoLabel ?? "—"}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <div className="p-4 border-t flex justify-end">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded text-sm font-medium text-gray-800"
                    >
                        {t("label_cerrar")}
                    </button>
                </div>
            </div>
        </div>
    );
}
